<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
            placeholder="Proszę podać co najmniej trzy znaki."
            v-model="productSearch"
            solo>
        </v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-data-table
            style="height: 400px; overflow: scroll"
            :items="results"
            :loading="searching"
            :no-data-text="'Brak wyników'"
            :total-items="results.length"
            :hide-actions="true"
            :hide-headers="true"
        >
          <template v-slot:items="props">
            <td>
              {{ props.item.name }}
              <template v-if="getOwnerIfShared(props.item)">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-icon v-on="on" small color="success">share</v-icon>
                  </template>
                  <span>{{ trans('app.sharing.shared_by', {name: getOwnerIfShared(props.item)}) }}</span>
                </v-tooltip>
              </template>
            </td>
            <td style="text-align: right">
              <v-btn small color="primary" @click="select(props.item)">
                Wybierz
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {mapGetters, mapMutations} from "vuex";
import {SharingService} from "../../services/SharingService";

export default {
  props: {
    food: {
      type: Object,
      required: false
    },
    plan: {
      type: Object,
      required: false
    },
    day: {
      type: Object,
      required: false
    },
    productToReplace: Object,
  },
  data: () => ({
    productSearch: '',
    results: [],
    searching: false
  }),
  methods: {
    ...mapMutations([
      'showModal',
    ]),
    select(productReplacement) {
      this.showModal({
        component: 'replace-product-modal',
        data: {
          productToReplace: this.productToReplace,
          food: this.food,
          plan: this.plan,
          day: this.day,
          productReplacement: productReplacement,
        },
      });
    },
    getOwnerIfShared(item) {
      return SharingService.getOwnerIfShared(this.configuration.sharedResources, item.externalId, 'product');
    }
  },
  watch: {
    productSearch(val) {
      if (val && val.length >= 3) {
        this.results = [];
        this.searching = true;
        axios.get(this.configuration.search.product + `?q=${val}&page=1&limit=100`)
            .then((response) => {
              this.results = response.data.data;
            }).catch((error) => {
              this.sentryCaptureException(error);
            }).finally(() => {
              this.searching = false;
            });
      } else {
        this.results = [];
      }
    },
  },
  computed: {
    ...mapGetters([
      'configuration',
    ]),
  },
}
</script>
